import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { FreeBetsProcedureState } from 'src/components/FreeBetsProcedure/FreeBetsProcedure.state';
import { FreeBetsActiveTable } from 'src/components/FreeBetsActiveTable/FreeBetsActiveTable';
import { FreeBetsForm } from 'src/components/FreeBetsForm/FreeBetsForm';
import { List } from 'immutable';
import MinimalistPopUp from 'src/components/MinimalistPopUp/MinimalistPopUp.jsx';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { FreeBetsActiveTableBonusEngine } from 'src/components/FreeBetsActiveTable/FreeBetsActiveTableBonusEngine';

interface FreeBetsProcedurePropsType {
    permissionGrants: List<unknown>;
    customerId: number;
    label: string;
    refreshFreebetLists: () => void;
    currency: CurrencyType;
}

export const FreeBetsProcedure = observer(
    'FreeBetsProcedure',
    ({ customerId, permissionGrants, refreshFreebetLists, currency }: FreeBetsProcedurePropsType) => {
        const { sdkStaff, reduxAction, bankingTabState } = useAppStateContext();
        const common = useCommon();
        const { config } = ConfigState.get(common);
        const bankingTabStateLocal = bankingTabState.get(customerId);

        const [state] = useState(
            () =>
                new FreeBetsProcedureState(
                    sdkStaff,
                    customerId,
                    permissionGrants,
                    reduxAction,
                    refreshFreebetLists,
                    common,
                    bankingTabStateLocal.cancelBonusBonusEngine
                )
        );

        return (
            <div className='freebets'>
                {config.showBonusEngine ? (
                    <FreeBetsActiveTableBonusEngine
                        currency={currency}
                        customerId={customerId}
                        permisionsAllowed={state.permisionsAllowed}
                        handleShowModal={state.handleShowModalBonusEngine}
                    />
                ) : (
                    <FreeBetsActiveTable
                        freebetCredits={state.freebetCredits}
                        currency={currency}
                        permisionsAllowed={state.permisionsAllowed}
                        handleShowModal={state.handleShowModal}
                    />
                )}

                <FreeBetsForm
                    permisionsAllowed={state.permisionsAllowed}
                    freebetCreditsTotalAmount={state.freebetCreditsToalAmount}
                    customerId={customerId}
                    currency={currency}
                    submitCallback={state.refreshResources}
                />

                {state.showModal === false ? null : (
                    <MinimalistPopUp
                        title='Delete Free Bet?'
                        actionButtonText='Delete'
                        isActive={state.showModal}
                        onClose={
                            config.showBonusEngine ? state.handleRemoveFreebetBonusEngine : state.handleRemoveFreebet
                        }
                    >
                        <p>Are you sure you want to delete the free bet?</p>
                        {config.showBonusEngine ? null : (
                            <>
                                <p>If so, please provide a reason:</p>
                                <input
                                    type='text'
                                    onChange={state.handleChangeReason}
                                    name='reason'
                                    value={state.reason}
                                    placeholder='Enter the reason'
                                    className='minimalist-popup__input'
                                />
                            </>
                        )}
                    </MinimalistPopUp>
                )}
            </div>
        );
    }
);
